import { useState, useEffect } from 'react';

// This hook is used in several places where we render
// both desktop and mobile elements initially. This is
// sometimes necessary when using the useMatchMedia hook.

// Because viewport size can't be calculated during SSR,
// we conditionally render both mobile/desktop layouts
// initially and use CSS to show/hide them. This
// helps avoid the layout jumping on mobile
// during the initial SSR hydration
export default function useHasRendered() {
  const [hasRendered, setHasRendered] = useState(false);

  useEffect(() => {
    setHasRendered(true);
  }, []);

  return hasRendered;
}
